const decodeEmail = (str) => str.replace(/[a-zA-Z]/g, (char) => {
    const code = char.charCodeAt(0) + 13;
    return String.fromCharCode((char <= "Z" ? 90 : 122) >= code ? code : code - 26);
});

const openMailer = (element) => {
    const email = element.getAttribute("data-email");
    const linkString = "mailto:";
    const addressString = decodeEmail(email);
    element.setAttribute("href", linkString + addressString);
    element.removeAttribute("onclick");
};

globalThis.openMailer = openMailer;
